import DisplayItem from '@/models/DisplayItem';
import Test from '@/models/Test';
import INavigationController from '../INavigationController';
import AbstractNavigationState from './AbstractNavigationState';
import NavigationCallbackType from './NavigationCallbackType';
import NavigationContext from './NavigationContext';
import NavigationStateDisplayType from './NavigationStateDisplayType';

class TestEndNavigationState extends AbstractNavigationState {
  constructor(
    navigationController: INavigationController,
    navigationContext: NavigationContext,
    lockSectionsEnabled: boolean
  ) {
    super(navigationController, navigationContext, lockSectionsEnabled);
  }

  handleForwardNavigation(navigationCallback: (NavigationCallbackType) => void): void {
    const item: DisplayItem | null = this.navigationController.getCurrentItem();

    if (!item) {
      this.navigationContext.setNavigationState(NavigationContext.ITEM_STATE);
      navigationCallback(NavigationCallbackType.NEXT);
      return;
    }

    this.displayIncompleteAlert(
      this.lockSectionsEnabled ? item.section.getIncompleteCount() : item.section.testPart.test.getIncompleteCount(),
      this.lockSectionsEnabled ? item.section.getFlaggedCount() : item.section.testPart.test.getFlaggedCount(),
      false,
      () => {
        this.navigationContext.setNavigationState(NavigationContext.ITEM_STATE);
        navigationCallback(NavigationCallbackType.NEXT);
      },
      null
    );
  }

  handleBackNavigation(navigationCallback: (NavigationCallbackType) => void): void {
    this.navigationContext.setNavigationState(NavigationContext.ITEM_STATE);
    navigationCallback(NavigationCallbackType.NONE);
  }

  handleCurrentItemNavigation(navigationCallback: (NavigationCallbackType) => void): void {
    this.navigationContext.setNavigationState(NavigationContext.ITEM_STATE);
    navigationCallback(NavigationCallbackType.CURRENT);
  }

  handleReviewSubmit(navigationCallback: (NavigationCallbackType) => void): void {
    navigationCallback(NavigationCallbackType.NONE);
  }

  getLocationState(): number {
    return Test.TEST_END_STATE;
  }

  getDisplayType(): NavigationStateDisplayType {
    return NavigationStateDisplayType.TEST_REVIEW;
  }
}

export default TestEndNavigationState;
